<template>
  <v-layout row>
    <v-flex xs12 sm12  lg12>
      <v-card>
        <v-form>
          <v-card-title primary-title>
            <h3 class="headline mb-0">Editar responsable</h3>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="form.quotes_id"
              :error="validated.errorQuote"
              :error-messages="validated.messageQuote"
              :items="quotes"
              label="Cita"
              item-text="description"
              item-value="id"
            ></v-select>
          <v-select
            autocomplete
            v-model="form.responsable"
            :error="validated.errorResponsable"
            :error-messages="validated.messageResponsable"
            :items="selectResposable"
            label="Responsable"
            item-text="description"
            item-value="id"
          ></v-select>
            <v-text-field
              :error="validated.name_as"
              :error-messages="validated.messageName_as"
              type="text"
              label="Nombre para mostrar"
              v-model="form.nameAs"
            ></v-text-field>
            <v-text-field
              type="text"
              label="Link para reuniones"
              v-model="form.url_for_meeting"
            ></v-text-field>
          </v-card-text>
          <v-flex >
            <v-btn flat small @click="create" color="blue darken-1" >Actualizar</v-btn>
          </v-flex>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
    import Form from 'vform';
    import axios from 'axios'
    export default {
        name: "create",
        data: () => ({
            quotes: [],
            selectResposable:[
                {'id': 1, description: 'German'},
                {'id': 2, description: 'david'},
                {'id': 3, description: 'Patiño'},
            ],
            validated:{
                errorQuote: false,
                errorResponsable: false,
                name_as: false,
                messageName_as: '',
                message: '',
            },
            form: {
                id: '',
                nameAs: '',
                quotes_id: '',
                responsable: '',
                url_for_meeting: '',
            }
        }),
        methods: {
            validateSelct () {
                if(this.form.quotes_id == undefined) {
                    this.validated.messageQuote = 'Esta campo no puede estar vacío';
                    this.validated.errorQuote = true;
                    return true
                }else{
                    this.validated.messageQuote = '';
                    this.validated.errorQuote = false;
                }
                if (this.form.responsable == undefined){
                    this.validated.messageResponsable = 'Esta campo no puede estar vacío';
                    this.validated.errorResponsable = true;
                }else{
                    this.validated.errorResponsable = false;
                    this.validated.messageResponsable = '';

                }
                if (this.form.nameAs == null){
                    this.validated.messageName_as = 'Esta campo no puede estar vacío';
                    this.validated.name_as = true;
                    return true
                }else{
                    this.validated.messageName_as = '';
                    this.validated.name_as = false;
                }
                return false;
            },
            setEdit(data){
                console.log(data)
                this.form.quotes_id = data.quotes_id
                this.form.responsable = parseInt(data.responsable_name)
                this.form.id = data.id
                this.form.nameAs = data.name_as
                this.form.url_for_meeting = data.url_for_meeting
            },
            async create() {
                let valited = this.validateSelct()
                if (!valited){
                if (await this.formHasErrors()) return

               axios.post('/api/quotes/responsable/update', this.form)
                    .then(resp=>{
                        this.$emit('create')
                        console.log('resp', resp);
                        if (resp.data.status == 201){
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: this.$t('eventcategorys.create-form.stored-ok-text'),
                            title: this.$t('eventcategorys.create-form.stored-ok-title'),
                            modal: true
                        })
                        }
                    }).catch(err=>{
                        console.log(err)
                    })
                }
            },
            getQuotes () {
                axios.get('/api/quotes/all')
                    .then(resp=>{
                        this.quotes = resp.data.data
                    })
            },
            getEmploye(){
                axios.get('api/quotes/get/employes')
                    .then(resp=>{
                        this.selectResposable = resp.data.data.map(obj=>{
                           return {
                               id: obj.id,
                               description: obj.name + ' - ' + obj.username
                           }
                        });
                        console.log(resp.data)
                    }).catch(error=>{

                })
            }
        },
        created() {
            this.getEmploye()
            this.getQuotes()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/responsibleAppointment/edit.vue